export const MAX_CART_ITEM_QUANTITY = 99;

export const enum CART_PAGE_EVENT {
	REMOVE_ITEM = "CartPageEvent.RemoveItem",
	CONFIRM_REMOVE_ITEM = "CartPageEvent.ConfirmRemoveItem",
	RESTORE_TO_BEFORE_REMOVE = "CartPageEvent.Restore",
	CLEAR_CART = "CartPageEvent.ClearCart",
	REFRESH_PAGE = "CartPageEvent.Refresh",
	CHOOSE_DINEIN_TAKEAWAY = "CartPageEvent.ChooseDineInTakeaway",
	CHANGE_DINEIN_TAKEAWAY = "CartPageEvent.ChangeDineInTakeaway",
	SHOW_ITEM_LIMIT_MODAL = "CartPageEvent.ShowItemLimitModal",
}
